<template>
  <v-sheet id="printOnly">
    <v-container class="page" :key="order.id" v-for="order in orders">
      <v-layout justify-space-between row>
        <v-flex>
          <div>
            <span class="font-weight-black"> Order Id: </span>
            {{ order.tracking_id }}
          </div>
          <div>
            <span class="font-weight-black"> Payment Mode: </span
            >{{ order.payment_method }}
          </div>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex shrink class="text-xs-right">
          <qr-code :text="qrtext(order)" :size="100"></qr-code>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex>
          <div><span class="font-weight-black">Ship From: </span></div>
          <div class="pl-3">
            <div :key="line" v-for="(line, i) in address">
              {{ line }} {{ i < address.length - 1 ? ',' : '' }}
            </div>
          </div>
        </v-flex>
        <v-flex>
          <div><span class="font-weight-black">Ship To:</span></div>
          <div class="pl-3">
            <span class="font-weight-black">Name</span>:
            {{ order.address.name }}
            <div v-if="order.address.house_number">
              <span class="font-weight-black">House/Flat No.</span>:
              {{ order.address.house_number }}
            </div>
            <div v-if="order.address.apartment">
              <span class="font-weight-black">Building/Apartment</span>:
              {{ order.address.apartment }}
            </div>
            <div>
              <span class="font-weight-black">Area/ Locality</span>:{{
                order.address.area
              }}
            </div>
            <div>
              <span class="font-weight-black">City</span>:
              {{ order.address.city }}
            </div>
            <div>
              <span class="font-weight-black">Pincode</span>:
              {{ order.address.pincode }}
            </div>
            <div>
              <span class="font-weight-black">Phone</span> :
              {{ order.address.phone }}
            </div>
          </div>
        </v-flex>
      </v-layout>
      <v-layout class="mt-2">
        <table>
          <thead>
            <tr>
              <th>Sr. No.</th>
              <th>Name</th>
              <th>Description</th>
              <th>Unit Price</th>
              <th>Qty</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr :key="itm._id" v-for="(itm, i) in order.items">
              <td>
                {{ i + 1 }}
              </td>
              <td>
                {{ itm.name }}
              </td>
              <td>
                <template v-for="v in itm.variants">
                  <span :key="v.id" class="font-weight-black"
                    >{{ v.label }}:</span
                  >
                  {{ v.value.name }},
                </template>
              </td>
              <td>{{ discountedPrice(itm) }}</td>
              <td>
                {{ itm.quantity }}
              </td>
              <td>Rs. {{ itm.quantity * discountedPrice(itm) }}</td>
            </tr>
          </tbody>
        </table>
      </v-layout>
      <v-layout row xs12 wrap class="mt-2">
        <v-spacer></v-spacer>

        <v-flex class="text-xs-right" offset-6 xs3>
          <div><span class="font-weight-black">Sub Total: </span></div>
          <div>
            <span class="font-weight-black">Delivery Charges: </span>
          </div>
          <div><span class="font-weight-black">Total: </span></div>
        </v-flex>
        <v-flex class="text-xs-right" md3 xs2>
          <div>Rs.{{ order.total }}</div>
          <div>Rs.{{ order.delivery_charge }}</div>
          <div>
            <span class="font-weight-black">Rs.{{ order.total }}/-</span>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </v-sheet>
</template>
<style scoped>
#printOnly {
  display: none;
}

@media print {
  #printOnly {
    display: block;
  }
  thead {
    display: table-header-group;
  }
  .font-weight-black {
    display: inline-block !important;
    color: black !important;
    font-weight: bolder !important;
  }
  .page {
    page-break-before: always;
  }
}
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #dddddd;
}
.font-weight-black {
  display: inline-block !important;
  color: black !important;
  font-weight: bolder !important;
}
</style>
<script>
import VueQRCodeComponent from 'vue-qrcode-component';
import { mapGetters } from 'vuex';
export default {
  components: { qrCode: VueQRCodeComponent },
  props: ['orders'],
  computed: {
    ...mapGetters(['config']),
    address() {
      if (this.config)
        return this.config.address ? this.config.address.split(',') : [];
      return [];
    },
  },
  methods: {
    qrtext(order) {
      return JSON.stringify({
        orderId: order.id,
        trackingId: order.tracking_id,
      });
    },
  },
};
</script>
